export default "__VITE_ASSET__6LsAhwCa__"